export const formatImportLogEntry = (entry) => {
  const timestamp = entry?.timestamp ? new Date(entry.timestamp).toLocaleString("it-IT") : "";
  const level = (entry?.level || "INFO").padEnd(7);
  return `[${timestamp}] ${level} | ${entry?.message || ""}`;
};

export const formatJobSeparator = (date = new Date()) => (
  `--- Import ${date.toLocaleString("it-IT")} ---`
);

export const formatActivitySeparator = (activity, vendorId, date = new Date()) => (
  `--- ${activity} vendor ${vendorId} ${date.toLocaleString("it-IT")} ---`
);

export const formatLocalLogLine = (message, level = "INFO", date = new Date()) => {
  const timestamp = date.toLocaleString("it-IT");
  const normalizedLevel = String(level || "INFO").padEnd(7);
  return `[${timestamp}] ${normalizedLevel} | ${message}`;
};

export const appendImportLogs = (previousLines, logs = [], options = {}) => {
  const chunks = [];
  if (options.separator) {
    if (previousLines.length > 0) {
      chunks.push("");
    }
    chunks.push(options.separator);
    chunks.push("");
  }
  if (logs.length) {
    const existing = new Set(previousLines);
    const formatted = logs.map(formatImportLogEntry).filter((line) => !existing.has(line));
    if (formatted.length) {
      chunks.push(...formatted);
    }
  }
  if (!chunks.length) {
    return previousLines;
  }
  const merged = [...previousLines, ...chunks];
  const MAX_LOG_LINES = 6000;
  return merged.length > MAX_LOG_LINES ? merged.slice(-MAX_LOG_LINES) : merged;
};

export const importJobAlertSeverity = (status) => {
  if (status === "FAILED" || status === "PARTIAL_FAILED" || status === "DOWNLOAD_FAILED" || status === "PARSE_FAILED") {
    return "error";
  }
  if (status === "COMPLETED_WITH_ERRORS" || status === "MAPPING_REVIEW") return "warning";
  if (status === "COMPLETED") return "success";
  return "info";
};
